var VISIBILITY_FILTERS;
(function (VISIBILITY_FILTERS) {
    VISIBILITY_FILTERS[VISIBILITY_FILTERS["ALL"] = 0] = "ALL";
})(VISIBILITY_FILTERS || (VISIBILITY_FILTERS = {}));
var ACTIONS;
(function (ACTIONS) {
    ACTIONS["GET"] = "GET";
    ACTIONS["REQUEST_AUTHENTICATE"] = "REQUEST_AUTHENTICATE";
    ACTIONS["RECEIVE_AUTHENTICATE"] = "RECEIVE_AUTHENTICATE";
    ACTIONS["RECEIVE_AUTH_DENIED"] = "RECEIVE_AUTH_DENIED";
    ACTIONS["REQUEST_INIT"] = "REQUEST_INIT";
    ACTIONS["RECEIVE_INIT"] = "RECEIVE_INIT";
    ACTIONS["REQUEST_LOGOUT"] = "REQUEST_LOGOUT";
    ACTIONS["RECEIVE_LOGOUT"] = "RECEIVE_LOGOUT";
    ACTIONS["MQTT_MESSAGE_RECEIVED"] = "MQTT_MESSAGE_RECEIVED";
    ACTIONS["API_TRANSACTION_START"] = "API_TRANSACTION_START";
    ACTIONS["API_TRANSACTION_END"] = "API_TRANSACTION_END";
    ACTIONS["SAVE_OBJECT"] = "SAVE_OBJECT";
    ACTIONS["RECEIVE_SAVE_TRANSACTION_RESULT"] = "APP_RECEIVE_SAVE_TRANSACTION_RESULT";
    ACTIONS["DELETE_OBJECT"] = "DELETE_OBJECT";
    ACTIONS["RECEIVE_DELETE_TRANSACTION_RESULT"] = "RECEIVE_DELETE_TRANSACTION_RESULT";
    ACTIONS["SET_USER_MESSAGE"] = "SET_USER_MESSAGE";
    ACTIONS["DISMISS_USER_MESSAGE"] = "DISMISS_USER_MESSAGE";
    ACTIONS["RECEIVE_SAVE_AND_LINK_TRANSACTION_RESULT"] = "RECEIVE_SAVE_AND_LINK_TRANSACTION_RESULT";
    ACTIONS["REQUEST_NEW_LIST_OBJECT"] = "REQUEST_NEW_LIST_OBJECT";
    ACTIONS["REQUEST_SEARCH_BY_TYPE"] = "REQUEST_SEARCH_BY_TYPE";
    ACTIONS["RECEIVE_SEARCH_BY_TYPE_RESULT"] = "RECEIVE_SEARCH_BY_TYPE_RESULT";
    ACTIONS["REQUEST_UNLINK_OBJECTS"] = "REQUEST_UNLINK_OBJECTS";
    ACTIONS["RECEIVE_UNLINK_OBJECTS_RESULT"] = "RECEIVE_UNLINK_OBJECTS_RESULT";
    ACTIONS["REQUEST_LINK_OBJECTS"] = "REQUEST_LINK_OBJECTS";
    ACTIONS["REQUEST_GET_ADJACENTS"] = "REQUEST_GET_ADJACENTS";
    ACTIONS["RECEIVE_GET_ADJACENT_RESULT"] = "RECEIVE_GET_ADJACENT_RESULT";
    ACTIONS["REQUEST_REFRESH_WITH_USER_TOKEN"] = "REQUEST_REFRESH_WITH_USER_TOKEN";
    ACTIONS["RECIEIVE_REFRESH_WITH_USER_TOKEN"] = "RECIEIVE_REFRESH_WITH_USER_TOKEN";
    ACTIONS["CANCEL_REDIRECT_AFTER_SUCCESS"] = "CANCEL_REDIRECT_AFTER_SUCCES";
    ACTIONS["GET_USER_GEOLOCATION"] = "GET_USER_GEOLOCATION";
    ACTIONS["RECEIVE_USER_GEOLOCATION"] = "RECEIVE_USER_GEOLOCATION";
    ACTIONS["REQUEST_GET_DEVICE_FROM_REGISTRY"] = "REQUEST_GET_DEVICE_FROM_REGISTRY";
    ACTIONS["RECEIVE__GET_DEVICE_FROM_REGISTRY_RESULT"] = "RECEIVE__GET_DEVICE_FROM_REGISTRY_RESULT";
    ACTIONS["MQTT_NETWORK_MESSAGE_RECEIVED"] = "MQTT_NETWORK_MESSAGE_RECEIVED";
    ACTIONS["CLEAR_MESSAGE_PING"] = "CLEAR_MESSAGE_PING";
    ACTIONS["CHANGE_APP_STATE"] = "CHANGE_APP_STATE";
    ACTIONS["REQUEST_ADD_OBJECTS_TO_STATE"] = "REQUEST_ADD_OBJECTS_TO_STATE";
    ACTIONS["REQUEST_RENOVE_OBJECTS_FROM_STATE"] = "REQUEST_RENOVE_OBJECTS_FROM_STATE";
    ACTIONS["RECEIVE_OBJECTS_IN_STATE"] = " RECEIVE_OBJECTS_IN_STATE";
    ACTIONS["REQUEST_GET_LARGE_OBJECT"] = "REQUEST_GET_LARGE_OBJECT";
    ACTIONS["RECEIVE_GET_LARGE_OBJECT"] = "RECEIVE_GET_LARGE_OBJECT";
    ACTIONS["REQUEST_UPLOAD_FILE"] = "REQUEST_UPLOAD_FILE";
    ACTIONS["RECEIVE_FILEUPLOAD_RESULT"] = "RECEIVE_FILEUPLOAD_RESULT";
    ACTIONS["RECEIVE_SWITCH_ROLES_RESULT"] = "RECEIVE_SWITCH_ROLES_RESULT";
    ACTIONS["REQUEST_CHANGE_USER_ROLE"] = "REQUEST_CHANGE_USER_ROLE";
    ACTIONS["RECEIVE_CHANGE_USER_ROLE_RESULT"] = "RECEIVE_CHANGE_USER_ROLE_RESULT";
    ACTIONS["RECEIVE_CONTEXT_CUSTOMERS"] = "RECEIVE_CONTEXT_CUSTOMERS";
    ACTIONS["NEW_PASSWORD_REQUIRED"] = "NEW_PASSWORD_REQUIRED";
    ACTIONS["RECEIVE_THING_TYPES_MAP"] = "RECEIVE_THING_TYPES_MAP";
    ACTIONS["RECEIVE_LINK_OBJECTS_TO_PRIMARY"] = "RECEIVE_LINK_OBJECTS_TO_PRIMARY";
})(ACTIONS || (ACTIONS = {}));
export { VISIBILITY_FILTERS, ACTIONS };
